class SectionTwoColumnUSP extends window.BAO.CustomElement() {
  static get requiredElements () {
    return [
      'usp',
      'uspsContainer',
      'uspImageContainer',
      'mediaContainer',
    ]
  }

  connectedCallback () {
    super.connectedCallback()

    this.preloadImages()
    this.insertImageElements()

    this.dataset.ready = 'true'
  }

  checkValidity () {
    super.checkValidity()
  }

  setupListeners () {
    super.setupListeners()

    this.els.usp.elements.forEach(el => {
      this.listeners.add(el, 'mouseenter', this.onMouseEnter.bind(this))
      this.listeners.add(el, 'mouseleave', this.onMouseLeave.bind(this))
    })
  }

  /**
   * @param {MouseEvent & { target: HTMLElement }} event
   */
  onMouseEnter (event) {
    const usp = event.target
    const image = this.getUspImage(usp)
    if (!image) return

    const index = event.target.dataset.index
    const imageContainer = this.querySelector(
      `[data-section-two-column-usp-el="desktopImageContainer"][data-index="${index}"]`,
    )

    imageContainer.setAttribute('aria-hidden', 'false')

    this.uspImageActive = true

    usp.classList.add('sec-TwoColumnUSP_Item-active')
  }

  /**
   * @param {MouseEvent & { target: HTMLElement }} event
   */
  onMouseLeave (event) {
    const usp = event.target
    const image = this.getUspImage(event.target)
    if (!image) return

    const index = event.target.dataset.index
    const imageContainer = this.querySelector(
      `[data-section-two-column-usp-el="desktopImageContainer"][data-index="${index}"]`,
    )

    imageContainer.setAttribute('aria-hidden', 'true')

    this.uspImageActive = false

    usp.classList.remove('sec-TwoColumnUSP_Item-active')
  }

  preloadImages () {
    this.els.usp.elements.forEach(el => {
      const img = this.getUspImage(el)
      img.crossOrigin = 'anonymous'
      const image = new Image()
      image.src = img.src
      image.srcset = img.srcset
      image.sizes = img.sizes
      image.width = img.width
      image.height = img.height
    })
  }

  insertImageElements () {
    this.els.usp.elements.forEach((el, index) => {
      const img = this.getUspImage(el)
      const clone = this.els.desktopImageTemplate.element.content.cloneNode(
        true,
      )
      const image = clone.querySelector('img')

      this.applyNewImage(image, img)

      const container = clone.firstElementChild
      container.dataset.index = index.toString()

      this.els.mediaContainer.element.appendChild(clone)
    })
  }

  /**
   * @param {HTMLElement} el
   */
  getUspImage (el) {
    const imageContainer = el.querySelector(this.els.uspImageContainer.selector)
    if (!imageContainer) return null

    return imageContainer.querySelector('img')
  }

  /**
   * @param {HTMLImageElement} image1
   * @param {HTMLImageElement | { src: string, srcset: string, sizes: string }} image2
   */
  applyNewImage (image1, image2) {
    image1.src = image2.src
    image1.srcset = image2.srcset
    image1.sizes = image2.sizes
  }

  get uspImageActive () {
    return this.dataset.uspImageActive === 'true'
  }

  set uspImageActive (val) {
    this.dataset.uspImageActive = val.toString()
  }
}

if (!customElements.get('section-two-column-usp')) {
  customElements.define(
    'section-two-column-usp',
    SectionTwoColumnUSP,
  )
}
